module.exports = __webpack_public_path__ + "static/img/3.596b04d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/eng/3.png
// module id = ylQ7
// module chunks = 0